<template>
  <div class="flex items-center gap-4 p-2">
    <!-- Image skeleton -->
    <USkeleton class="w-16 h-16 rounded" />
    
    <!-- Content skeleton -->
    <div class="flex flex-col gap-2 flex-1">
      <USkeleton class="h-4 w-3/4" />
      <USkeleton class="h-3 w-1/2" />
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
